module.exports = __webpack_public_path__ + "static/media/v_logo_cerave_crop.c0f542ec.png";